import { PackagesBody } from 'modules/arena/reports/model/bodies';
import { formatCount } from 'modules/arena/reports/model/format';
import { KpiGrid } from 'modules/arena/reports/components/KpiCard';
import { Panel } from 'modules/arena/reports/components/Panel';
import { DataTable } from 'modules/arena/reports/components/DataTable';
import { AreaProps } from 'modules/arena/reports/areas/shared';
import { MagnitudeBarList } from 'shared/components/charts/MagnitudeBarList';

export function PackagesArea({ body, meta, controller }: AreaProps<PackagesBody>) {
  const { changeTable, tableLoading } = controller;
  const withContracts = body.byPlan.filter((plan) => plan.value > 0);
  return (
    <div className="flex flex-col gap-6">
      <KpiGrid metrics={body.metrics} meta={meta} />

      <Panel title="Contratos vigentes por plano" subtitle="Frequência como contratada — não convertida em aulas por mês">
        {withContracts.length ? (
          <MagnitudeBarList items={withContracts} formatValue={(value) => `${formatCount(value)} contrato(s)`} />
        ) : (
          <p className="text-sm text-ink-secondary">Nenhum contrato vigente no período.</p>
        )}
      </Panel>

      <DataTable
        title="Contratos"
        table={body.table}
        loading={tableLoading}
        onChange={changeTable}
        footnote="Turma fixa e horário flexível são tipos diferentes. Renovação pendente ainda não é perda do aluno."
      />
    </div>
  );
}
